import { currencyFormatterNull } from "../../../components/Charts";
import { Series } from "../../../components/Charts/MultipleLine/types";
import { SavingsHistoryResponse } from "../../../services";
import { formatMonthLabel } from "../../../utils";
import { SavingsGrowth } from "../types";

export const buildSavingsGrowth = (
  history: SavingsHistoryResponse,
): SavingsGrowth => {
  const xLabels = history.data.map((point) => formatMonthLabel(point.date));
  const balanceData = history.data.map((point) => point.value);
  const contributedData = history.data.map((point) => point.contributed);

  const series: Series[] = [
    {
      id: "balance",
      data: balanceData,
      label: "Balance",
      area: true,
      showMark: false,
      color: "var(--color-success)",
      valueFormatter: currencyFormatterNull,
    },
    {
      id: "contributed",
      data: contributedData,
      label: "Net contributed",
      area: false,
      dashed: true,
      showMark: false,
      color: "var(--color-text-secondary)",
      valueFormatter: currencyFormatterNull,
    },
  ];

  return {
    xLabels,
    series,
  };
};
